// extracted by mini-css-extract-plugin
export default {"add-tasks":"AddTasks_add-tasks__AvTOF","header":"AddTasks_header__Djr2L","box":"AddTasks_box__Vv1TB","submit":"AddTasks_submit__bCAFv"};